import { useDomain } from '../hooks/useDomain.js'

export const Image = ({ src, alt, ...rest }) => {
  const { subfolder } = useDomain()
  if (src.indexOf('/') === 0 && src.indexOf('//') !== 0) {
    src = `${subfolder}${src}`
  }

  return <img src={src} alt={alt || ''} {...rest} />
}
